import { defineMessages } from 'react-intl';

export const scope = 'app.components.TipDirect.ReviewFirstModal';

export default defineMessages({
  title: {
    id: `${scope}.title`,
    defaultMessage: 'Review page first'
  },
  description: {
    id: `${scope}.description`,
    defaultMessage:
      'Choose what this guide shows a customer who opens their tip link.'
  },
  inheritLabel: {
    id: `${scope}.inherit_label`,
    defaultMessage: 'Use the company setting'
  },
  inheritOnHelp: {
    id: `${scope}.inherit_on_help`,
    defaultMessage: 'Your company currently shows the review page first.'
  },
  inheritOffHelp: {
    id: `${scope}.inherit_off_help`,
    defaultMessage: 'Your company currently shows the tipping page first.'
  },
  onLabel: {
    id: `${scope}.on_label`,
    defaultMessage: 'Always show the review page first'
  },
  onHelp: {
    id: `${scope}.on_help`,
    defaultMessage:
      'Customers leave a review before they reach the tipping form. They can still tip afterwards.'
  },
  offLabel: {
    id: `${scope}.off_label`,
    defaultMessage: 'Always show the tipping page first'
  },
  offHelp: {
    id: `${scope}.off_help`,
    defaultMessage:
      'Customers land straight on the tipping form, even when the company setting is on.'
  },
  save: {
    id: `${scope}.save`,
    defaultMessage: 'Save'
  }
});
